import React from 'react';
import { Box, Text, Heading, Link } from '@chakra-ui/react';
import CollapsibleItems from '../../components/shared/CollapsibleItems';

const FAQ_ITEMS = [
  {
    title: 'Does the homeowner receive the measurements as well?',
    content:
      "No, the homeowner receives the 3D model without any measurements. They do receive access to HOVER's design features so they can experiment with the look of the exterior of their property.",
  },
  {
    title:
      'How will I know that the homeowner has submitted photos of their home and that the 3D model is ready?',
    content:
      'In your Property Portfolio, you can see whether the homeowner registered with HOVER and submitted the photos. We’ll also send you an email when the homeowner uploads photos of their home and when the 3D model and measurements PDF are ready.',
  },
  {
    title: 'At what point will I be billed?',
    content:
      'You will be billed when you receive the 3D model with all exterior measurements.',
  },
];

const FAQSection = () => (
  <Box backgroundColor="gray.50" p="5">
    <Box maxW="5xl" mx="auto">
      <Heading
        mt="14"
        mb="20"
        textAlign="center"
        fontSize="4xl"
        fontWeight="extrabold"
      >
        Frequently Asked Questions
      </Heading>
      <CollapsibleItems items={FAQ_ITEMS} isUnderlined />

      <Text textAlign="center" my="16" fontSize="lg">
        Still have questions? Reach out to our{' '}
        <Link href="/contact">Support Team</Link> for help.
      </Text>
    </Box>
  </Box>
);

export default FAQSection;
